import * as CryptoJS from 'crypto-js';

export class CryptJsSettingsInRegisterFav {
  public static KEY = CryptoJS.enc.Utf8.parse('ovzhkgkvbsybdi5p');
  public static IV = CryptoJS.enc.Utf8.parse('86bzksg7690i6iwj');
}

export class CryptJsSettingsInAutoAct {
  public static KEY = CryptoJS.enc.Utf8.parse('f5rrru06vlkn31t4');
  public static IV = CryptoJS.enc.Utf8.parse('2e6wxylw0ss4d53y');
}
